import { UUID as UUIDC, type UUID } from 'io-ts-types/UUID';

export const UUID_PATTERN_SOURCE = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export const isUuid = (value: unknown): value is UUID => UUIDC.is(value);
